/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import context
 */

import { AppContext } from "context/appContext";

/**
 * import components
 */

import { Button__radio } from "components/button/button";
import { Content__tooltip } from "components/content/content";

/**
 * styled components
 */
const Container = styled.div`
  position: relative;
  ${t.mixins.flex({ justify: "flex-start" })}
  width: calc(100% / 3);

  ${t.mixins.sm(`
    padding: 9px 6px;
    width: calc(100% / 2);
  `)}
`;
const Radio = styled(Button__radio)`
  ${t.mixins.rem(13, 13)}
`;
const Tooltip = styled(Content__tooltip)`
  margin-left: 2px;
`;

/**
 * filter component is..
 */

const Item__filter = ({ title, id, tooltip }) => {
  const { updateFilters, userFilters } = useContext(AppContext);
  const selected = userFilters.includes(id);
  return (
    <Container>
      <Radio title={title} onClick={() => updateFilters(id)} selected={selected} />
      {tooltip && <Tooltip content={tooltip} size={15} />}
    </Container>
  );
};

export default Item__filter;

Item__filter.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Item__filter.defaultProps = {
  style: {},
};

/*
    import Item__filter from 'components/item/filter/item__filter'
    <Item__filter />
  */
